import { render, staticRenderFns } from "./headersP.vue?vue&type=template&id=b8ad4630&scoped=true&"
import script from "./headersP.vue?vue&type=script&lang=js&"
export * from "./headersP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ad4630",
  null
  
)

export default component.exports